import React from "react";

import { MenuList as ReachMenuList } from "@reach/menu-button";

type MenuListProps = React.HTMLAttributes<HTMLDivElement> & {
  portal?: boolean | undefined;
  children: React.ReactNode;
} & React.RefAttributes<HTMLDivElement>;

const MenuList: React.FC<MenuListProps> = ({ children, ...props }) => {
  return (
    <ReachMenuList
      {...props}
      className="mt-2 border-0 rounded-md shadow-lg min-w-xxs"
    >
      {children}
    </ReachMenuList>
  );
};

export default React.memo(MenuList);
